// extracted by mini-css-extract-plugin
export var container = "PrintDish-module--container--lX9Wn";
export var imageWrapper = "PrintDish-module--imageWrapper--gl9vk";
export var ingredientsContainer = "PrintDish-module--ingredientsContainer--+rPQC";
export var insideImageWrapper = "PrintDish-module--insideImageWrapper--sJP17";
export var textField = "PrintDish-module--textField--vcolp";